import { isTenantSmava } from 'utils/url'

function useTenant() {
  const tenant: Tenant = isTenantSmava() ? 'smava' : 'ffg'

  return {
    tenant,
    isSmava: tenant === 'smava',
    isFfg: tenant === 'ffg'
  }
}

export default useTenant
